export default "__VITE_ASSET__CxJ9F4gi__"